import { Component, Input, OnInit, OnChanges, SimpleChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { FilterOption, FilterResponse } from '@client/app/shared-modules/filter/types/filter.type';
import { MonFilterService } from '@client/app/shared-modules/filter/services/filter.service';
import { ChipModule } from 'primeng/chip';

@Component({
    selector: 'mon-filter-display',
    standalone: true,
    templateUrl: './filter-display.component.html',
    styleUrl: './filter-display.component.scss',
    imports: [
        CommonModule,
        TranslocoModule,
        ChipModule,
    ],
})
export class FilterDisplayComponent implements OnInit, OnChanges {
    @Input() filters: FilterResponse = {};
    filtersArray = signal<{ key: string; values: FilterOption[] }[]>([]);
    isFiltersPresent: boolean = false;

    constructor (
        public readonly filterService: MonFilterService,
    ) {}

    ngOnInit (): void {
        this.updateFiltersArray();
    }

    ngOnChanges (changes: SimpleChanges): void {
        if (changes['filters']) {
            this.updateFiltersArray();
        }
    }

    removeFilterValue (filterKey: string, value: FilterOption): void {
        if (Array.isArray(this.filters[filterKey])) {
            this.filters[filterKey] = this.filters[filterKey].filter((v) => v !== value);
        } else {
            this.filters[filterKey] = null;
        }

        this.updateFiltersArray();

        this.filterService.filterResponse.set(this.filters);
    }

    // Format filter keys from camelCase to "Camel case"
    formatFilterKey (key: string): string {
        const words = key.replace(/([A-Z])/g, ' $1').trim();
        return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
    }

    private updateFiltersArray (): void {
        this.filtersArray.set(
            Object.entries(this.filters)
                .map(([key, value]) => ({
                    key,
                    values: Array.isArray(value) ? value : value !== null && value !== undefined ? [value] : [],
                })),
        );

        this.isFiltersPresent = this.filtersArray().some(f => f.values?.length);
    }
}

